// import images from './images';
// import icons, { Administration, Assistant, Cleaning, Furniture, Gardening, HomeRepair, Lifter, Packing, Plumbing } from './icons';
import { MdOutlineDesignServices } from "react-icons/md";
import { BsBarChartLine } from "react-icons/bs";
import { GiProcessor } from "react-icons/gi";
import { GrDeploy, GrShieldSecurity } from "react-icons/gr";
import { RiCodeView } from "react-icons/ri";
import { VscServerProcess } from "react-icons/vsc";
import {
  a1,
  a2,
  a3,
  a4,
  a5,
  b1,
  b2,
  b3,
  b4,
  b5,
  b6,
  p1,
  p10,
  p11,
  p2,
  p3,
  p4,
  p5,
  p6,
  p7,
  p8,
  p9,
  w1,
  w2,
  w3,
  w4,
  w5,
} from "./images";
const footerArray1 = [
  {
    title: "Home",
  },
  {
    title: "My Team",
  },
];

const footerArray2 = [
  {
    title: "Why Choose Me",
  },
  {
    title: "Contact Me",
  },
];

const footerArray3 = [
  {
    title: "About Me",
  },
  {
    title: "Contact Me",
  },
  {
    title: "Careers",
  },
  {
    title: "FAQ",
  },
];

const services = [
  {
    id: 1,
    icon: <RiCodeView />,
    title: "Software Development",
    desc: `Unleash the full potential of your infrastructure with my top-notch DevOps services — from CI/CD automation to scalable cloud deployments, I ensure smooth, secure, and efficient operations for your digital products.`,
  },

  {
    id: 1,
    icon: <BsBarChartLine />,
    title: "Business Intelligence",
    desc: `I provide a complete suite of data management, reporting, and analytics tools that enable organisations to access and analyse their data in real-time.`,
  },
  {
    id: 1,
    icon: <GrDeploy />,
    title: "DevOps",
    desc: `I work closely with you to understand your infrastructure and deployment needs, and craft a custom DevOps strategy tailored to your unique requirements. From CI/CD pipelines to cloud infrastructure and automation, I ensure your systems are scalable, secure, and efficient.`,
  },
];

const apps = [
  {
    id: 1,
    icon: p11,
    title: "Helpicon",
    desc: `View More`,
    link: "https://play.google.com/store/apps/details?id=com.helpicon.app&pcampaignid=web_share",
  },
  {
    id: 1,
    icon: p4,
    title: "Scribd",
    desc: `View More`,
    link: "https://www.scribd.com/",
  },
  {
    id: 2,
    icon: p2,
    title: "Simma",
    desc: `View More`,
    link: "https://play.google.com/store/apps/details?id=com.vs.simma&hl=en&gl=US&pli=1",
  },
  {
    id: 3,
    icon: p8,
    title: "TextNG",
    desc: `View More`,
    link: "http://www.textnextgen.com/",
  },
  {
    id: 4,
    icon: p7,
    title: "Black Dollar Bill",
    desc: `View More`,
    link: "https://appadvice.com/app/black-dollar-bill/1533220311",
  },
  {
    id: 5,
    icon: p3,
    title: "Smokey Maps",
    desc: `View More`,
    link: "https://smokeymaps.com/",
  },
  {
    id: 6,
    icon: p9,
    title: "QISST Pay",
    desc: `View More`,
    link: "https://qisstpay.com/",
  },

  {
    id: 7,
    icon: p1,
    title: "Agent Pulse",
    desc: `View More`,
    link: "http://agentpulseapp.com/",
  },

  {
    id: 8,
    icon: p5,
    title: "Scotoma",
    desc: `View More`,
    link: "https://scotomatechnologies.com/",
  },

  {
    id: 9,
    icon: p6,
    title: "NoHalt",
    desc: `View More`,
    link: "https://apps.apple.com/us/app/nohalt/id1467944318",
  },

  {
    id: 11,
    title: "30+",
    desc: `Projects`,
    link: "",
  },
];

const websites = [
  {
    id: 1,
    icon: w4,
    title: "CDM Smith",
    desc: `View More`,
    link: "https://www.cdmsmith.com/en/",
  },
  {
    id: 2,
    icon: w3,
    title: "WDP2",
    desc: `View More`,
    link: "https://www.wateen.com/",
  },
  {
    id: 3,
    icon: w5,
    title: "Social Eeye",
    desc: `View More`,
    link: "https://socialeye.ai/",
  },
  {
    id: 4,
    icon: w2,
    title: "Wateen Telecom Limited",
    desc: `View More`,
    link: "https://www.wateen.com/",
  },
  {
    id: 3,
    title: "20+",
    desc: `Projects`,
    link: "",
  },
];

const ai_list = [
  {
    id: 5,
    icon: a5,
    title: "Face Attendance Recognition",
    desc: `View More`,
    link: "",
  },
  {
    id: 3,
    icon: a3,
    title: "Production Guard",
    desc: `View More`,
    link: "",
  },
  {
    id: 4,
    icon: a4,
    title: "Retail Surveillance",
    desc: `View More`,
    link: "",
  },
  {
    id: 2,
    icon: a2,
    title: "Card Identity Verification",
    desc: `View More`,
    link: "",
  },
  {
    id: 1,
    icon: a1,
    title: "Cancer Diagnosis",
    desc: `View More`,
    link: "",
  },

  {
    id: 6,
    title: "10+",
    desc: `Projects`,
    link: "",
  },
];

const bi_list = [
  {
    id: 1,
    icon: b1,
    title: "Revenue Dashboard",
    desc: `View More`,
    link: "",
  },
  {
    id: 2,
    icon: b2,
    title: "Incident Management Dashboard",
    desc: `View More`,
    link: "",
  },
  {
    id: 3,
    icon: b4,
    title: "Vendor Dashboard",
    desc: `View More`,
    link: "",
  },
  {
    id: 4,
    icon: b5,
    title: "Inventory Management Dashboard",
    desc: `View More`,
    link: "",
  },
  {
    id: 5,
    icon: b6,
    title: "HR Dashboard",
    desc: `View More`,
    link: "",
  },

  {
    id: 6,
    title: "15+",
    desc: `Projects`,
    link: "",
  },
];

export {
  footerArray1,
  footerArray2,
  footerArray3,
  services,
  apps,
  websites,
  ai_list,
  bi_list,
};
// export { images, services, footerArray1, footerArray2, footerArray3, chooseUs,earnMoney };
